import { render } from "./ParcoursSlug.vue?vue&type=template&id=20f104c5"
import script from "./ParcoursSlug.vue?vue&type=script&lang=js"
export * from "./ParcoursSlug.vue?vue&type=script&lang=js"

import "./ParcoursSlug.vue?vue&type=style&index=0&id=20f104c5&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__